import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useCallback, useMemo, useContext } from 'react';
import { Box, Button, ButtonGroup, Typography } from '@mui/material';
import { Notification, User } from 'z3k-config';
import { Call, Message } from '@mui/icons-material';
import { Z3KSettings, Z3KSettingsEditor } from 'z3k-settings/provider/types';
export const TestNotification = memo(function TestNotification(props) {
    const { item } = props;
    const { sendCommand } = useContext(Z3KSettings);
    const { config } = useContext(Z3KSettingsEditor);
    const telephone = useMemo(() => {
        if (item.recipient_list.length > 0) {
            const raw_phone = User.get.one(config, ({ id }) => id == item.recipient_list[0])?.phone;
            if (raw_phone) {
                const trimmed_phone = raw_phone.trim();
                if (trimmed_phone.match(/^([ \s()+-]*([0-9][\s()+-]*){6,20})/)) {
                    return trimmed_phone;
                }
            }
        }
        return null;
    }, [config.users, item.recipient_list]);
    const is_sms = useMemo(() => Notification.isSmsEnabled(item) || Notification.isSmsIfCallFailed(item), [item.setting_register]);
    const is_voice = useMemo(() => Notification.isVoiceEnabled(item), [item.setting_register]);
    const sendSmsCommand = useCallback(() => {
        if (telephone == null) {
            return;
        }
        sendCommand(null, 'SendSMSToUser', { telephone, message: item.sms_text }, null, true);
    }, [sendCommand, telephone, item.sms_text]);
    const sendDialCommand = useCallback(() => {
        if (telephone == null) {
            return;
        }
        sendCommand(null, 'DialUser', { telephone });
    }, [sendCommand, telephone]);
    return (_jsxs(Box, { display: "flex", flexDirection: "column", children: [_jsx(Typography, { variant: "subtitle1", color: "textSecondary", children: "\u0422\u0435\u0441\u0442 \u043E\u043F\u043E\u0432\u0435\u0449\u0435\u043D\u0438\u0439" }), _jsxs(ButtonGroup, { variant: "outlined", fullWidth: true, disabled: telephone == null, children: [is_sms && (_jsx(Button, { onClick: sendSmsCommand, startIcon: _jsx(Message, {}), children: "C\u043C\u0441" })), is_voice && (_jsx(Button, { color: "primary", size: "small", onClick: sendDialCommand, startIcon: _jsx(Call, {}), children: "\u0414\u043E\u0437\u0432\u043E\u043D" }))] }), _jsx(Typography, { variant: "body2", color: "textSecondary", children: "\u043F\u0435\u0440\u0432\u043E\u043C\u0443 \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u0435\u043B\u0435\u0439" })] }));
});
